export default "__VITE_ASSET__or05D3Fh__"